// useCoolingDefaults — fetch the active tenant's Precool prefill defaults
// (packhouse_config.cooling_defaults, mig 20260729150622). Returns the raw
// config blob; callers resolve with the pure fns in coolingDefaults.ts so the
// same logic is unit-testable without React. Mirrors useCoolingSla's shape.

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useActiveTenant } from '@/lib/useActiveTenant'

export function useCoolingDefaults(): unknown {
  const { data: tenant } = useActiveTenant()
  const tenantId = tenant?.tenantId ?? null
  const { data } = useQuery({
    queryKey: ['cooling-defaults', tenantId],
    enabled: !!tenantId,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('packhouse_config')
        .select('cooling_defaults')
        .eq('tenant_id', tenantId!)
        .maybeSingle()
      if (error) throw error
      return (data?.cooling_defaults ?? null) as unknown
    },
  })
  return data ?? null
}
